import { ChangeDetectionStrategy, Component, computed, effect, input, signal, ViewEncapsulation } from '@angular/core';
import { EnpsControlComponent } from '@common/controls/enps-control/enps-control';
import { Table } from '@common/data-models/complex-types/table';

import { ComboBoxComponent } from '../combo-box/combo-box';
import { TextFieldComponent } from '../text-field/text-field';

@Component({
    selector: 'st-special',
    imports: [ComboBoxComponent, TextFieldComponent],
    templateUrl: './special.html',
    styleUrl: './special.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-special',
    },
})
export class SpecialComponent extends EnpsControlComponent<Table> {
    // TODO MAKE A TYPE FOR THIS PLEASE
    readonly columns = input<any[]>();

    readonly internalValue = signal<Table>(null);

    readonly model = computed(() => {
        return this.internalValue()?.data || [];
    });

    constructor() {
        super();
        effect(() => {
            let val = this.value();
            if (!val?.colMetadata?.length) {
                val = new Table();
                val.colMetadata = this.columns();
                val.addEmptyRowIfNeeded();
            }
            this.internalValue.set(val);
        });
    }

    getValue(row: number, col: number): any {
        return this.internalValue()?.get(row, col) || '';
    }

    valueChanged(value: string | number, row: number, col: number) {
        this.internalValue.update(val => {
            val.set(row, col, value);
            return val;
        });
        this.changed.emit(this.internalValue());
    }
}
